// extracted by mini-css-extract-plugin
export default {"container":"final-proof-sent_container__NUj3B"};